import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import is from '../../../_snowpack/pkg/styled-is.js';
import { colors } from '../colors.js';
import { sizes } from '../sizes.js';
import { responsive } from '../responsive.js';
export const Input = styled.input.withConfig({
  displayName: "input__Input",
  componentId: "sc-1vwi0xo-0"
})(["border:none;height:45px;font-size:1rem;background:", ";color:", ";width:", ";outline:none;position:relative;padding:10px 20px;border-bottom:1px solid transparent;box-shadow:0px 2px 4px rgba(211,207,244,0.2);", ";", " ", ";", ";", ";", ";", ";", ";", ";", ";", ";", " ", ";&:focus{border-bottom-color:", ";}&::-webkit-input-placeholder{font-size:0.9rem;font-weight:400;opacity:0.7;}", " ", ";", ";", ";", ""], colors.lightGrey, colors.frostbite, p => p.width || 'auto', is('compact')`
    height: 35px;
  `, is('default')`
    background:#fff;
    border-radius:25px;
    font-weight:500;
    width:100%;
    position:relative;
  `, is('shape')`
    padding:0 40px;
  `, is('white')`
    background: #fff;
  `, is('bold')`
    font-weight:600;
  `, is('line')`
    border-bottom: 1px solid ${colors.glacier};
    background: transparent;
  `, is('noBorder')`
    border: none;
  `, is('readOnly')`
    cursor: default;
  `, is('right')`
    text-align: right;
  `, is('fullWidth')`
    width: 100% !important;
    margin-right: 0;
  `, is('forMobile')`
    ${responsive.xs} {
      font-size: 22px;
    }
  `, is('clean')`
    border-radius:30px;
    background:transparent;
    &:hover {
      background: rgba(0,0,0,.05);
    }
    &:active, &:focus {
      background:#fff ;
    }
  `, is('titleInput')`
      background:transparent;
      font-size:28px;
      font-family:'Roboto Slab', sans-serif;
      height:auto;
      padding-left: 70px;
      &:hover {
        background:rgba(0,0,0,0.03);
      }
      &:focus, &:active {
        background:#fff;
      }

  `, colors.glacier, is('shapeInput')`
     border-radius:2px;
     height:auto;
     padding: 15px 20px;
     background:#fff;
     width:100%;
     border:1px solid rgba(0,0,0,0.0);
     margin-top:-8px;
     margin-bottom:5px;
    &:focus, &:hover {
      background:#fff;
      border:1px solid rgba(0,0,0,0.05);
    }
    &:focus {
      border:1px solid ${colors.glacier};
    }

    &::-webkit-input-placeholder {
      font-size: 0.9rem;
      opacity:0.6;
    }
  `, is('price')`
    background:#fff;
    border-radius:30px;
  `, is('currencyRight')`
    border-radius:30px 0 0 30px;
  `, is('subscription')`
    border-radius:25px 0 0 25px;
  `, is('outline')`
    border: 1px solid #0000001a;
    border-radius:25px;
    width:100%;

    &:focus {
      border-bottom-color: #0000001a;
    }
  `);
const InputWrapperCmp = styled.div.withConfig({
  displayName: "input__InputWrapperCmp",
  componentId: "sc-1vwi0xo-1"
})(["position:relative;&:before{content:'';position:absolute;top:0;left:0;height:45px;width:100%;z-index:1;}&:after{background:", ";width:80%;height:30px;bottom:-2px;content:'';position:absolute;left:10%;z-index:0;filter:blur(8px);opacity:0.05;}"], colors.frostbite);
const InputWrapperContent = styled.div.withConfig({
  displayName: "input__InputWrapperContent",
  componentId: "sc-1vwi0xo-2"
})(["position:relative;z-index:2;"]);
export const InputWrapper = ({
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(InputWrapperCmp, rest, /*#__PURE__*/React.createElement(InputWrapperContent, null, children));
export const InputGroup = styled.div.withConfig({
  displayName: "input__InputGroup",
  componentId: "sc-1vwi0xo-3"
})(["margin-right:15px;margin-bottom:25px;", " ", " ", ";"], is('width')`
    width: ${p => p.width};
  `, is('minWidth')`
    min-width: ${p => p.minWidth};
  `, is('fullWidth')`
    width: 100% !important;
    margin-right: 0;
  `);
export const InputGroupGrid = styled.div.withConfig({
  displayName: "input__InputGroupGrid",
  componentId: "sc-1vwi0xo-4"
})(["flex:1 0 100%;display:grid;grid-template-columns:repeat(", ",1fr);grid-column-gap:", ";grid-row-gap:", ";margin-bottom:25px;", "{grid-template-columns:repeat(1,1fr);}", "{margin:0;}"], p => p.cols || 2, sizes.small, sizes.small, responsive.xs, InputGroup);
export const InputLabel = styled.label.withConfig({
  displayName: "input__InputLabel",
  componentId: "sc-1vwi0xo-5"
})(["display:block;font-size:10px;text-transform:uppercase;padding-bottom:5px;opacity:0.5;padding-left:20px;font-weight:600;"]);
export const InputError = styled.div.withConfig({
  displayName: "input__InputError",
  componentId: "sc-1vwi0xo-6"
})(["margin-top:", ";color:", ";font-size:0.7rem;padding-left:20px;"], sizes.tiny, colors.error);